import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FormSelection = () => {
    const navigate = useNavigate();
    const [showRegistration, setShowRegistration] = useState(true);
    const [userData, setUserData] = useState(null);

    React.useEffect(() => {
        const savedUser = localStorage.getItem('workshopUser');
        if (savedUser) {
            setUserData(JSON.parse(savedUser));
            setShowRegistration(false);
        }
    }, []);

    const handleRegistration = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const user = {
            name: formData.get('name'),
            email: formData.get('email'),
            company: formData.get('company')
        };
        localStorage.setItem('workshopUser', JSON.stringify(user));
        setUserData(user);
        setShowRegistration(false);
    };

    const forms = [
        // {
        //     id: 'ai-workshop-mar-2025-london',
        //     title: 'AI Workshop March 2025 London',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'lcc-june-2025',
        //     title: 'London Chamber Of Commerce London June 2025',
        //     description: 'Building Your Digital Workforce',
        //     icon: '🇬🇧'
        // },
        // {
        //     id: 'bcc-june-2025',
        //     title: 'Birmingham Chamber of Commerce June 2025',
        //     description: 'Building Your Digital Workforce',
        //     icon: '🇬🇧'
        // },
        // {
        //     id: 'ai-transform-2025',
        //     title: 'AI Transform 2025',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'your-future-digial-workshop-london-2025',
        //     title: 'Your Future Digital Workshop London 2025',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // }
        // {
        //     id: 'ideas-fest-uk-2025',
        //     title: 'Ideas Fest UK 2025',
        //     description: 'The festival for entrepreneurs, business leaders, disruptors, change-makers and decsision-makers!',
        //     icon: '⚡️'
        // }
        // {
        //     id: 'your-future-digial-workshop-manchester-2025',
        //     title: 'Your Future Digital Workshop Manchester 2025',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'festival-of-entrpreneurs-2025',
        //     title: 'Festival Of Entrpreneurs',
        //     description: '8-9 October 2025  |  NEC Birmingham',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'your-future-digial-workshop-london-2026',
        //     title: 'Your Future Digital Workshop London 2026',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'your-future-digial-workshop-dubai-2026',
        //     title: 'Your Future Digital Workshop Dubai 2026',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        // {
        //     id: 'putting-ai-to-work-london-2026',
        //     title: 'Putting AI to Work London 2026',
        //     description: 'Building Your Digital Workforce',
        //     icon: '⚡️'
        // },
        {
            id: 'putting-ai-to-work-manchester-2026',
            title: 'Putting AI to Work Manchester 2026',
            description: 'Building Your Digital Workforce',
            icon: '⚡️'
        }
    ];

    if (showRegistration) {
        return (
            <div className="min-h-screen bg-[#FAF9F6] flex flex-col items-center justify-center p-4">
                <div className="mb-8">
                    <img src="/iai-logo.png" alt="Implement AI" className="h-12 w-auto" />
                </div>
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
                    <h2 className="text-2xl font-bold text-black mb-6 text-center">Workshop Registration</h2>
                    <form onSubmit={handleRegistration} className="space-y-4">
                        <div>
                            <label htmlFor="name" className="block text-sm font-medium text-black mb-1">Name</label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#8C52FF] focus:border-[#8C52FF]"
                                placeholder="Enter your name"
                            />
                        </div>
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-black mb-1">Email</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#8C52FF] focus:border-[#8C52FF]"
                                placeholder="Enter your email"
                            />
                        </div>
                        <div>
                            <label htmlFor="company" className="block text-sm font-medium text-black mb-1">Company</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                required
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#8C52FF] focus:border-[#8C52FF]"
                                placeholder="Enter your company name"
                            />
                        </div>
                        <button
                            type="submit"
                            className="w-full bg-[#8C52FF] text-white py-2 px-4 rounded-md hover:bg-[#7B3FE3] transition-colors duration-200"
                        >
                            Register
                        </button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#FAF9F6] flex flex-col items-center p-4">
            <div className="mb-8 mt-8">
                <img src="/iai-logo.png" alt="Implement AI" className="h-12 w-auto" />
            </div>
            <div className="max-w-4xl w-full">
                <div className="text-center mb-8">
                    <h1 className="text-3xl font-bold text-black mb-2">Welcome, {userData?.name}</h1>
                    <p className="text-lg text-black">Please select your workshop:</p>
                </div>
                <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                    {forms.map(form => (
                        <button
                            key={form.id}
                            onClick={() => navigate(`/workshop?form=${form.id}`)}
                            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 text-left"
                        >
                            <div className="text-4xl mb-4">{form.icon}</div>
                            <h3 className="text-xl font-semibold text-black mb-2">{form.title}</h3>
                            <p className="text-black">{form.description}</p>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FormSelection; 